import styled, { css } from "styled-components";
import { socketServer } from "../../assets/socketConnection";

// console.log(process.env);
// // alert("hi");
// const xx = "process.env.mainServer";

const profileImgStyles = (profile_img) => css`
  background-image: url("${socketServer}uploaded_profile_images/${profile_img}.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
export const ShareLoad = styled.div`
  display: flex;
  align-items: center;
  /* border: 1px solid; */
  margin: 10px 0;
  padding: 5px;
  border-radius: 8px;
  font-size: 10px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(53,58,80,0.2);
`;
export const ShareLoadIcon = styled.div`
  background-color: #2a2e43;
  border: 1px solid;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left:5px ;
`;
export const ProgressBtnStyled = styled.div`
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  margin: 10px 0;
  /* padding: 5px; */
  border-radius: 8px;
  text-align: center;
  background-color: rgba(255, 191, 29, 0.2);
  color: #ffbf1d;
  cursor: pointer;
`;
export const ProgressBtnContent = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

export const SelectedBitContStyled = styled.div`
  position: relative;
  padding-top: 50px;

  & > .selected-bit__title {
    display: flex;
    align-items: center;
    background-color: #ecedf0;
    padding: 6px;
    border-radius: 12px;
  }

  & .selected-bit__img {
    width: 48px;
    height: 48px;
    margin-left: 12px;

    border: solid 1px #2a2e43;
    background-color: rgba(42, 46, 67, 0.2);
    border-radius: 8px;

    ${({ profile_img }) => {
      // console.log(profile_img);
      // debugger;
      return profile_img ? profileImgStyles(profile_img) : null;
    }}
  }

  & > .selected-bit__price {
    padding: 6px;
    border-radius: 8px;
    text-align: center;
    font-size: 1.2em;
    margin-top: 30px;
    background-color: #ffbf1d;
  }

  .selected-bit__pelak {
    border: solid 1px #8a8d98;
    color: #999ca8;
    border-radius: 10px;
    line-height: 1;
    padding: 2px 4px;
    width: 80px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.95em;

    position: relative;
    .selected-bit__pelak__sep {
      height: 100%;
      width: 1.5px;
      background-color: #8b8d9a;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 18px;
    }
  }

  & > .selected-bit__tel {
    border-radius: 8px;
    border: solid 1px #2a2e43;
    padding: 7px;
  }

  .selected-bit__tel__icon {
    position: absolute;
    left: 8px;
    top: 6px;
  }

  .btn--border {
    border-radius: 8px;
    flex-grow: 1;
    flex-basis: 45%;
    padding: 5px;
    border: solid 1px #2a2e43;
  }
`;
